export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-white border-b border-neutral-200 px-6 sm:px-8 py-5 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4"
    >
      <div>
        <div className="mono text-[11px] uppercase tracking-widest text-[#525252]">
          {subtitle}
        </div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold mt-1">{title}</h1>
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function Stat({ label, value, sub, accent, testId }) {
  return (
    <div
      data-testid={testId}
      className="erp-panel p-4 h-full flex flex-col justify-between fade-up"
    >
      <div className="mono text-[10px] uppercase tracking-widest text-[#525252]">
        {label}
      </div>
      <div
        className="mono text-xl sm:text-2xl font-semibold mt-3 break-words"
        style={accent ? { color: accent } : undefined}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-[#525252] mt-1">{sub}</div>}
    </div>
  );
}

export function Panel({ title, right, children, className = "", testId }) {
  return (
    <div data-testid={testId} className={`erp-panel flex flex-col ${className}`}>
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-neutral-200">
        <div className="mono text-[11px] uppercase tracking-widest text-[#525252]">
          {title}
        </div>
        {right}
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}

const KAT_STYLE = {
  "Produk Sudah Bergulir": "bg-green-50 text-green-700 border-green-300",
  "Produk Dalam Pengembangan": "bg-amber-50 text-amber-700 border-amber-300",
  "Produk Baru Diversifikasi": "bg-indigo-50 text-indigo-700 border-indigo-300",
};

export function KatBadge({ value }) {
  if (!value) return <span className="text-neutral-400">—</span>;
  return (
    <span
      className={`inline-block border px-1.5 py-0.5 text-[10px] uppercase tracking-wide ${
        KAT_STYLE[value] || "bg-neutral-50 text-neutral-600 border-neutral-300"
      }`}
    >
      {value.replace("Produk ", "")}
    </span>
  );
}
